import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, resolveDynamicComponent as _resolveDynamicComponent, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, openBlock as _openBlock, createBlock as _createBlock, normalizeClass as _normalizeClass, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8ede75d2"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["id"]
const _hoisted_2 = ["id"]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      id: `overlay_${_ctx.elementId}`,
      class: "overlay",
      onClick: _cache[0] || (_cache[0] = (...args) => (_ctx.onCloseByOutsideClick && _ctx.onCloseByOutsideClick(...args))),
      style: _normalizeStyle({ zIndex: _ctx.modal.index ? _ctx.modal.index - 1 : 1 })
    }, null, 12, _hoisted_1),
    _createElementVNode("div", {
      id: _ctx.elementId,
      class: _normalizeClass(`modal-bottom-dynamic-page ${_ctx.modal.name} state-${_ctx.state}`),
      style: _normalizeStyle(
    _ctx.elementBottom !== null
      ? { bottom: `${_ctx.elementBottom}px`, zIndex: _ctx.modal.index }
      : { zIndex: _ctx.modal.index }
  )
    }, [
      (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.dynamicComponent), _normalizeProps(_guardReactiveProps({ onClose: _ctx.onClose, ..._ctx.modal.props })), null, 16))
    ], 14, _hoisted_2)
  ], 64))
}